import React, { useRef, useEffect, useState } from 'react';
import { Image, Transformer } from 'react-konva';
import useImage from 'use-image';

export default function ImageElement({ 
  element, 
  isSelected, 
  isBeingEdited,
  onSelect, 
  onDragEnd, 
  onTransformEnd,
  canEdit 
}) {
  const imageRef = useRef(null);
  const transformerRef = useRef(null);
  
  const props = element.properties || {};
  const src = props.src || '';
  
  const [image] = useImage(src, 'anonymous');
  
  // Attach transformer when selected
  useEffect(() => {
    if (isSelected && transformerRef.current && imageRef.current) {
      transformerRef.current.nodes([imageRef.current]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  if (!image) return null;

  return (
    <>
      <Image
        ref={imageRef}
        x={element.x}
        y={element.y}
        width={element.width}
        height={element.height}
        image={image}
        rotation={element.rotation || 0}
        scaleX={element.scale_x || 1}
        scaleY={element.scale_y || 1}
        draggable={canEdit}
        onClick={(e) => onSelect(element.id, e)}
        onTap={(e) => onSelect(element.id, e)}
        onDragEnd={(e) => {
          onDragEnd(element.id, { x: e.target.x(), y: e.target.y() });
        }}
        onTransformEnd={() => {
          const node = imageRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          
          node.scaleX(1);
          node.scaleY(1);
          
          onTransformEnd(element.id, {
            x: node.x(),
            y: node.y(),
            width: Math.max(20, node.width() * scaleX),
            height: Math.max(20, node.height() * scaleY),
            rotation: node.rotation()
          });
        }}
        stroke={isSelected ? '#3B82F6' : (isBeingEdited ? isBeingEdited.color : 'transparent')}
        strokeWidth={isSelected || isBeingEdited ? 2 : 0}
      />
      
      {isSelected && canEdit && (
        <Transformer
          ref={transformerRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 20 || newBox.height < 20) {
              return oldBox;
            }
            return newBox;
          }}
          rotateEnabled={true}
          keepRatio={true}
        />
      )}
    </>
  );
}
